import React, { useContext, useRef, useState } from 'react'
import  {Link, Navigate, useNavigate } from 'react-router-dom';
import logo from '../../assets/slider-2.jpeg';
import {cartContext} from '../Contexts/CartContext';

export default function Navbar({token,logOut}) {

let {cartNum}=useContext(cartContext);
let btnToggle=useRef();
const [togle, settogle] = useState(false);
let navigate=useNavigate();
function openNavbar() {
 
  if(btnToggle.current.getAttribute('aria-expanded')=='true')
  {
  settogle(true);
  }
  else{
    settogle(false);
  }
}
 function setLogout() {

  logOut();
  navigate('/login')
  
 }


  return <div className='mb-5'>
  
  <nav className="navbar navbar-expand-lg navbar-light fixed-top pb-3 ">
  <div className="container">
    <div className="MyLogo">
    <i className="fa-solid fa-cart-shopping fs-2 text-main"></i>
    <a className="navbar-brand" href="#">FreshCart</a>
    </div>
    
    <button className="navbar-toggler border-0 shadow-none" onClick={openNavbar} ref={btnToggle} type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      {!togle?<span className="navbar-toggler-icon border-0"></span>:<i className="fa-solid fa-xmark fs-1"></i>}
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      {token ==null && localStorage.getItem('token')==null?'':<ul className="navbar-nav  leftNav me-auto mb-2 mb-lg-0 ">
        <li className="nav-item">
        <Link className="nav-link " aria-current="page" to="/home">Home</Link>

          </li> 
          <li className="nav-item">
        <Link className="nav-link " aria-current="page" to="/products">Products</Link>

          </li> 
          
          <li className="nav-item">
        <Link className="nav-link " aria-current="page" to="/categories">Categories</Link>

          </li> 
          <li className="nav-item">
        <Link className="nav-link " aria-current="page" to="/brands">Brands</Link>

          </li> 
       
      
      </ul>}
      
         
      <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">

      
        
        {token ==null  && localStorage.getItem('token')==null? <><li className="nav-item">

<Link className="nav-link " aria-current="page" to="/register">Register</Link>

  </li>  <li className="nav-item">
        <Link className="nav-link " aria-current="page" to="/login">Login</Link>

          </li></> : <>
          <li className="nav-item">
        
        <Link className="nav-link position-relative" aria-current="page" to="/cart" >Cart<i className="fa-solid fa-cart-shopping fs-5 text-main"></i>
    {localStorage.getItem('cartNum')!=null && localStorage.getItem('token')!=null?<span className="position-absolute top-0 start-10 translate-middle badge mt-1 bg-success px-2">{localStorage.getItem('cartNum')!=0?localStorage.getItem('cartNum'):''}</span>:''}
    </Link>

          </li>
           <li className="nav-item">
        <Link className="nav-link " aria-current="page" to="/login" onClick={setLogout}>Log out</Link>

          </li><div className="dropdown ">
  <span className="btn  dropdown-toggle border-0"  id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">

   Welcome .. {localStorage.getItem('userName')} </span>
  <ul className="dropdown-menu border-0 " aria-labelledby="dropdownMenuButton1">
    <li><Link className="dropdown-item" to="/Changepassword">Change Your Password</Link></li>
    <li><Link className="dropdown-item" to="/Changeprofile">Change Your Profile</Link></li>
    
  </ul>
</div> </>}
        
       
      
      </ul>
     
    </div>
  </div>
</nav>
  
  
  
  </div>
  
}

